import { apiPostTextCSV } from 'utils/request';
import HOST from 'utils/globals';

export const checkCsv = file =>
  apiPostTextCSV(`${HOST}/invitedUsers/checkCSV`, file);
